<template>
  <div class="fpf-body">
    <el-row>
      <el-col>
        <div class="fpf-title">
          <span><strong>找回密码</strong></span>
        </div>
      </el-col>
      <el-col>
        <div class="content-panel">
          <el-form :model="phoneForm" :rules="phoneRules" ref="phoneForm">
            <el-form-item prop="phoneNo">
              <el-input placeholder="请输入手机号码" v-model="phoneForm.phoneNo"></el-input>
            </el-form-item>
            <el-form-item style="border: 1px solid #DCDFE6;border-radius: 4px;">
              <drag-verify
                ref="dragVerify"
                v-model:isPassing="isPassing"
                :width="365"
                text="请拖动滑块到最右边"
                successText="验证通过"
                background="#ccc"
                completedBg="rgb(0, 255, 0)"
                handlerIcon="el-icon-d-arrow-right"
                successIcon="el-icon-circle-check"
                @passcallback="passCallback"
              >
              </drag-verify>
            </el-form-item>
            <el-form-item prop="code">
              <el-input placeholder="短信验证码" v-model="phoneForm.code">
                <template #append>
                  <el-link type="primary" href="javascript:void(0)" :disabled="!isCodeEnable" @click="startCountdown">
                    获取验证码
                  </el-link>
                  <vue-countdown :time="time" v-slot="{ seconds }" v-if="counting" :autoStart="true"
                                 @end="onCountdownEnd">
                    （{{ seconds }} 秒）
                  </vue-countdown>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input placeholder="新密码，8-18位数字、字母和特殊字符组合" maxlength="18" show-password v-model="phoneForm.password"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPass">
              <el-input placeholder="请再次输入密码" show-password v-model="phoneForm.confirmPass"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="fpf-confirm" @click="handleConfirm">确认</el-button>
            </el-form-item>
            <div class="fpf-return">
              <el-link href="/#/login" :underline="false" type="primary">返回登录</el-link>
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { forwardBID } from '@/api/forward.js'
import VueCountdown from '@chenfengyuan/vue-countdown'
import DragVerify from '../vue-drag-verify/dragVerify'

export default {
  name: 'forget-password',
  components: { VueCountdown, DragVerify },
  data () {
    var validatePhoneNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空！'))
      }
      const regex = /^1[3456789]\d{9}$/
      if (!regex.test(value)) {
        callback(new Error('请输入正确的手机号码！'))
      } else {
        callback()
      }
    }
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        const patrn = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,18}$/
        if (!patrn.exec(value)) {
          return callback(new Error('新密码必须字母、数字、字符任意两种组成，密码长度最短8位'))
        }
        if (this.phoneForm.confirmPass !== '') {
          this.$refs.phoneForm.validateField('confirmPass')
        }
        callback()
      }
    }
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.phoneForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      phoneForm: {
        phoneNo: '',
        code: '',
        password: '',
        confirmPass: ''
      },
      phoneRules: {
        phoneNo: [
          {
            required: true,
            validator: validatePhoneNo,
            trigger: 'change'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入手机验证码！',
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassword,
            trigger: 'change'
          },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPass: [
          {
            required: true,
            validator: validateConfirmPass,
            trigger: 'change'
          }
        ]
      },
      time: 60 * 1000,
      counting: false, // 倒计时
      isPassing: false, // 滑动验证是否通过
      isCodeEnable: false // 验证码获取功能是否可用
    }
  },
  methods: {
    handleConfirm () {
      this.$refs.phoneForm.validate((valid) => {
        if (valid) {
          console.log(this.phoneForm.phoneNo + ' | ' + this.phoneForm.password + ' | ' + this.phoneForm.code)
          const data = {
            dateBackgroundUrl: '/bid/user/reset', // ^^^
            dateBackgroundRequestType: 'post',
            data: {
              mobile: this.phoneForm.phoneNo,
              password: this.phoneForm.password,
              verification: this.phoneForm.code
            }
          }
          forwardBID(data)
            .then(result => {
              if (result.code === 0) {
                ElMessage.success('密码修改成功！')
                this.$store.dispatch('logout')
                this.$router.push({ name: 'Login' })
              } else if (result.code === 1) {
                ElMessage.error(result.msg)
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    getVerifyCode () {
      console.log('this.phoneForm.phoneNo: ' + this.phoneForm.phoneNo)
      const data = {
        dateBackgroundUrl: '/bid/verifyCode/registergetVerifyCode',
        dateBackgroundRequestType: 'post',
        data: {
          mobile: this.phoneForm.phoneNo,
          verifyTypeCode: '7'
        }
      }
      forwardBID(data)
        .then(result => {
        })
        .catch(error => {
          console.log(error)
        })
    },
    onCountdownEnd () {
      this.time = 60 * 1000
      // this.isPassing = false
      this.counting = false
      this.isCodeEnable = true
    },
    startCountdown () {
      this.$refs.phoneForm.validateField('phoneNo', (error) => {
        if (!error) {
          this.isCodeEnable = false
          this.counting = true
          this.getVerifyCode()
        }
      })
    },
    passCallback () {
      this.isCodeEnable = true
    }
  }
}
</script>

<style scoped>
.fpf-body {
  padding: 0;
  display: flex;
  justify-content: center;
  /*border: 1px solid #ddd;*/
  /*border-radius: 8px;*/
  /*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
  width: 365px;
  height: 451px;
  background: #fff;
}

.fpf-title {
  font-size: 18px;
  color: #666666;
  margin: 20px;
}
.content-panel {

}

.fpf-confirm {
  width: 100%;
}

.fpf-return {
  display: flex;
  justify-content: flex-start;
}
</style>
